import HeaderActions from 'components/Header/Header.Actions'
import HeaderLogo from 'components/Header/Header.Logo'
import HeaderSearch from 'components/Header/Header.Search'
import { View } from 'components/View'
import { HeaderUserActions } from 'containers/Header/UserActions'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import React from 'react'
import NavLink from 'components/NavLink'
import pushRouterAction from 'modules/router/actions/push'
import { capitalizeStringUtil } from 'packages/src'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { HeaderBanner } from 'containers/HeaderBanner/index.js'
import { isOnlyInterestedInNutritionProfileSelect } from 'modules/profile/redux/selectors/getInterestFocus/index.js'

const NAVIGATION_MENU_ITEM = {
  HOME: 'home',
  APP: 'app',
  ARTICLES: 'articles',
  MOTIVATION: 'motivation',
  STORE: 'store'
  // CREATORS: 'creators'
}

// function loadUserActions () {
//   return import(/* webpackChunkName: "containers/Header/UserActions" */
// 'containers/Header/UserActions') }

/**
 * @param isEditing
 * @param route
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
export default function HeaderDesktop ({
  isEditing,
  route,
  ...rest
}) {
  const dispatch = useDispatch()
  const currentUser = useSelector(getCurrentUserSelector())
  const isInterestedInNutrition = useSelector(isOnlyInterestedInNutritionProfileSelect)

  const handleClickSearch = () => {
    dispatch(
      pushRouterAction(ROUTE_PATH.SEARCH)
    )
  }

  // const handleClickLogIn = () => {
  //   dispatch(
  //     openModalAction(MODAL_ID.SIGNIN)
  //   )
  // }

  const renderDesktopUserActions = () => {
    if (!currentUser) {
      return
    }
    return (
      <HeaderUserActions
        isEditing={isEditing}
        route={route}
        {...rest}
      />
    )
  }

  const renderDesktopActions = () => {
    return (
      <HeaderActions>
        {renderSearch()}
        {/* {renderLogIn()} */}
        {renderDesktopUserActions()}
      </HeaderActions>
    )
  }

  const getNavLinkProps = (name) => {
    let to = `/${name}`
    let end
    if (name === NAVIGATION_MENU_ITEM.HOME) {
      to = ROUTE_PATH.INDEX
    }

    if (to === ROUTE_PATH.INDEX) {
      end = true
    }

    return {
      end,
      to,
      style: ({ isActive }) => ({
        color: isActive ? '#191919' : 'currentColor',
        paddingRight: STYLES_PADDING.BIGGER
      })
    }
  }

  const renderDesktopNavigation = () => {
    return (
      <nav
        style={{
          color: '#666666',
          display: 'flex',
          flexGrow: '1',
          overflow: 'hidden',
          boxSizing: 'border-box',
          textTransform: 'uppercase',
          letterSpacing: '0.055em',
          fontSize: '0.77em',
          fontWeight: '500',
          lineHeight: '4.44em',
          flexDirection: View.DIRECTION.ROW,
          justifyContent: View.JUSTIFY.START,
          marginLeft: '4rem'
        }}
      >
        {
          Object
            .values(NAVIGATION_MENU_ITEM)
            .map(name => {
              const props = getNavLinkProps(name)
              const nameStr = capitalizeStringUtil(name)
              return (
                <NavLink key={name} {...props}>
                  {nameStr}
                </NavLink>
              )
            })
        }
      </nav>
    )
  }

  const renderSearch = () => {
    // If it's a small screen or editing or already in search
    // hide the icon
    if (
      isEditing ||
      route.section === SECTIONS_NAME.SEARCH
    ) {
      return
    }
    return <HeaderSearch onClick={handleClickSearch} />
  }

  // renderLogIn () {
  //   if (currentUser) {
  //     return
  //   }
  //   return (
  //     <HeaderButton
  //       onClick={handleClickLogIn}
  //       label={intl.formatMessage(messages.logIn)}
  //     />
  //   )
  // }

  return (
    <View>
      <View
        px={3}
        style={{
          flexDirection: View.DIRECTION.ROW,
          height: '4.44em',
          alignItems: View.ALIGN.CENTER
        }}
      >
        <HeaderLogo />
        {!isInterestedInNutrition && renderDesktopNavigation()}
        {!isInterestedInNutrition && renderDesktopActions()}
      </View>
      <HeaderBanner />
    </View>
  )
}
